"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const react_1 = __importStar(require("react"));
const rellax_1 = __importDefault(require("rellax"));
const RellaxWrapper = _a => {
  var {
      children,
      className,
      zIndex,
      speed,
      mobile,
      tablet,
      desktop,
      percentage,
      xs,
      style
    } = _a,
    options = __rest(_a, ["children", "className", "zIndex", "speed", "mobile", "tablet", "desktop", "percentage", "xs", "style"]);
  const [rellax, setRellax] = react_1.useState(null);
  const rellaxElement = react_1.useRef(null);
  react_1.useEffect(() => {
    if (rellaxElement.current) {
      setRellax(new rellax_1.default(rellaxElement.current, options));
    }
    return () => {
      if (rellax) {
        rellax.destroy();
      }
    };
  }, [rellaxElement]);
  return react_1.default.createElement("div", {
    ref: rellaxElement,
    "data-rellax-speed": speed && speed.toString(),
    "data-rellax-xs-speed": xs && xs.toString(),
    "data-rellax-mobile-speed": mobile && mobile.toString(),
    "data-rellax-tablet-speed": tablet && tablet.toString(),
    "data-rellax-desktop-speed": desktop && desktop.toString(),
    "data-rellax-zindex": zIndex && zIndex.toString(),
    "data-rellax-percentage": percentage && percentage.toString(),
    className: className,
    style: style
  }, children);
};
exports.default = RellaxWrapper;